import React, { createContext, useContext, useState } from 'react';

const translations = {
  en: {
    name: "Dr. Nawwaf Alshibli",
    title: "Spiritual Guide & Wisdom Teacher",
    heroDesc: "Discover the path to enlightenment through ancient wisdom and modern spiritual practices",
    selectLanguage: "Select Language",
    current: "Current",
    books: "Books",
    courses: "Courses",
    dubbed: "Dubbed",
    aboutUs: "About Us",
    login: "Login",
    welcomeTitle: "Welcome Message",
    welcomeDesc: "A personal message from Dr. Nawwaf Alshibli",
    coursesTitle: "Courses",
    coursesDesc: "Knowledge journeys to deepen your understanding and enrich your soul",
    viewCourse: "View the Course",
    comingSoon: "Coming Soon",
    dubbedTitle: "Dubbed Videos",
    dubbedDesc: "Watch our transformative videos in multiple languages",
    startLearning: "Start Learning",
    duration: "Duration",
    bookStoreTitle: "Official Book Store",
    bookStoreDesc: "Browse our curated collection of wisdom, spiritual guidance, and educational resources.",
    unableToLoad: "Unable to Load Store",
    retryConnection: "Retry Connection",
    askDrTitle: "Ask Dr. Nawwaf",
    askDrSubtitle: "Your Personal Spiritual Companion",
    askDrDesc: "Get instant answers to your spiritual questions based on Dr. Nawwaf's teachings. Our AI is trained to provide wisdom and guidance 24/7.",
    startChatting: "Start Chatting Now",
    aiPowered: "AI-Powered Spiritual Guidance",
    responsesNote: "* Responses are generated based on Dr. Nawwaf's published works",
    charitiesTitle: "Charities & Social Services",
    charitiesDesc: "Making a difference in communities worldwide",
    supportCause: "Support This Cause",
    teachingsTitle: "Teachings & Philosophy",
    teachingsDesc: "Rooted in ancient traditions, adapted for modern life",
    ourPhilosophy: "Our Philosophy",
    philosophyText1: "We believe that every individual carries a spark of the divine within them. Our mission is to help you fan that spark into a flame that illuminates your life and the lives of others.",
    philosophyText2: "Through understanding, compassion, and practice, we can overcome the barriers that separate us from our true selves and from each other.",
    philosophyText3: "Join us on this journey of self-discovery and spiritual growth, where ancient wisdom meets modern understanding.",
    missionTitle: "Mission & Vision",
    missionDesc: "Our commitment to a more enlightened world",
    ourVision: "Our Vision",
    visionQuote: "A world where every heart is awakened to its divine potential, living in harmony, peace, and conscious awareness.",
    donationTitle: "Support Our Mission",
    donationDesc: "Your contribution helps us continue spreading wisdom, supporting communities, and creating educational content for the world.",
    selectAmount: "Select Amount",
    custom: "Custom",
    totalDonation: "Total Donation",
    securePayment: "Secure payment via Stripe",
    taxDeductible: "Tax deductible receipt",
    sandboxNote: "* Sandbox Mode: Simulates a transaction to realitysound24@gmail.com"
  },
  ar: {
    name: "د. نواف الشبلي",
    title: "مرشد روحي ومعلم حكمة",
    heroDesc: "اكتشف طريق التنوير من خلال الحكمة القديمة والممارسات الروحية الحديثة",
    selectLanguage: "اختر اللغة",
    current: "الحالي",
    books: "الكتب",
    courses: "الدورات",
    dubbed: "مدبلج",
    aboutUs: "من نحن",
    login: "تسجيل الدخول",
    welcomeTitle: "رسالة ترحيبية من د. نواف",
    welcomeDesc: "رسالة شخصية من د. نواف الشبلي",
    coursesTitle: "الدورات",
    coursesDesc: "رحلات معرفية لتعميق فهمك وإثراء روحك",
    viewCourse: "شاهد الكورس",
    comingSoon: "قريباً",
    dubbedTitle: "دوراتنا المدبلجة",
    dubbedDesc: "استمع إلى دوراتنا التحويلية بلغات متعددة",
    startLearning: "ابدأ التعلم",
    duration: "المدة",
    bookStoreTitle: "المتجر الرسمي للكتب",
    bookStoreDesc: "تصفح مجموعتنا المنتقاة من الحكمة والإرشاد الروحي والموارد التعليمية",
    unableToLoad: "تعذر تحميل المتجر",
    retryConnection: "إعادة المحاولة",
    askDrTitle: "اسأل د. نواف",
    askDrSubtitle: "رفيقك الروحي الشخصي",
    askDrDesc: "احصل على إجابات فورية لأسئلتك الروحية بناءً على تعاليم د. نواف. ذكاءنا الاصطناعي مدرب لتقديم الحكمة والإرشاد على مدار الساعة.",
    startChatting: "ابدأ المحادثة الآن",
    aiPowered: "إرشاد روحي مدعوم بالذكاء الاصطناعي",
    responsesNote: "* الردود مُنشأة بناءً على أعمال د. نواف المنشورة",
    charitiesTitle: "الجمعيات الخيرية والخدمات الاجتماعية",
    charitiesDesc: "إحداث فرق في المجتمعات حول العالم",
    supportCause: "ادعم هذه القضية",
    teachingsTitle: "التعاليم والفلسفة",
    teachingsDesc: "متجذرة في التقاليد القديمة، مكيفة للحياة الحديثة",
    ourPhilosophy: "فلسفتنا",
    philosophyText1: "نؤمن بأن كل فرد يحمل شرارة من الإلهي بداخله. مهمتنا هي مساعدتك على إشعال تلك الشرارة لتصبح لهبًا ينير حياتك وحياة الآخرين.",
    philosophyText2: "من خلال الفهم والرحمة والممارسة، يمكننا التغلب على الحواجز التي تفصلنا عن ذواتنا الحقيقية وعن بعضنا البعض.",
    philosophyText3: "انضم إلينا في رحلة اكتشاف الذات والنمو الروحي، حيث تلتقي الحكمة القديمة بالفهم الحديث.",
    missionTitle: "المهمة والرؤية",
    missionDesc: "التزامنا بعالم أكثر استنارة",
    ourVision: "رؤيتنا",
    visionQuote: "عالم يستيقظ فيه كل قلب على إمكاناته الإلهية، يعيش في انسجام وسلام ووعي.",
    donationTitle: "ادعم مهمتنا",
    donationDesc: "مساهمتك تساعدنا على الاستمرار في نشر الحكمة ودعم المجتمعات وإنشاء محتوى تعليمي للعالم.",
    selectAmount: "اختر المبلغ",
    custom: "مخصص",
    totalDonation: "إجمالي التبرع",
    securePayment: "دفع آمن عبر Stripe",
    taxDeductible: "إيصال معفي من الضرائب",
    sandboxNote: "* وضع التجربة: يحاكي معاملة إلى realitysound24@gmail.com"
  },
  ru: {
    name: "Др. Навваф Альшибли",
    title: "Духовный наставник и учитель мудрости",
    heroDesc: "Откройте путь к просветлению через древнюю мудрость и современные духовные практики",
    selectLanguage: "Выберите язык",
    current: "Текущий",
    books: "Книги",
    courses: "Курсы",
    dubbed: "Дублированные",
    aboutUs: "О нас",
    login: "Войти",
    welcomeTitle: "Приветственное сообщение от Др. НОА",
    welcomeDesc: "Личное послание от Др. Навваф Альшибли",
    coursesTitle: "Курсы",
    coursesDesc: "Путешествия знаний для углубления понимания и обогащения души",
    viewCourse: "Смотреть курс",
    comingSoon: "Скоро",
    dubbedTitle: "Наши дублированные курсы",
    dubbedDesc: "Слушайте наши трансформационные курсы на разных языках",
    startLearning: "Начать обучение",
    duration: "Продолжительность",
    bookStoreTitle: "Официальный книжный магазин",
    bookStoreDesc: "Просмотрите нашу коллекцию мудрости, духовного руководства и образовательных ресурсов",
    unableToLoad: "Не удалось загрузить магазин",
    retryConnection: "Повторить попытку",
    askDrTitle: "Спросите Др. Навваф",
    askDrSubtitle: "Ваш личный духовный спутник",
    askDrDesc: "Получите мгновенные ответы на духовные вопросы на основе учений Др. Навваф. Наш ИИ обучен предоставлять мудрость и руководство 24/7.",
    startChatting: "Начать чат",
    aiPowered: "Духовное руководство на основе ИИ",
    responsesNote: "* Ответы генерируются на основе опубликованных работ Др. Навваф",
    charitiesTitle: "Благотворительность и социальные услуги",
    charitiesDesc: "Меняем мир к лучшему в сообществах по всему миру",
    supportCause: "Поддержать это дело",
    teachingsTitle: "Учения и философия",
    teachingsDesc: "Укоренены в древних традициях, адаптированы для современной жизни",
    ourPhilosophy: "Наша философия",
    philosophyText1: "Мы верим, что каждый человек несёт в себе божественную искру. Наша миссия — помочь вам разжечь эту искру в пламя, которое осветит вашу жизнь и жизни других.",
    philosophyText2: "Через понимание, сострадание и практику мы можем преодолеть барьеры, отделяющие нас от нашего истинного «я» и друг от друга.",
    philosophyText3: "Присоединяйтесь к нам в этом путешествии самопознания и духовного роста, где древняя мудрость встречается с современным пониманием.",
    missionTitle: "Миссия и видение",
    missionDesc: "Наша приверженность более просветлённому миру",
    ourVision: "Наше видение",
    visionQuote: "Мир, в котором каждое сердце пробуждено к своему божественному потенциалу, живя в гармонии, мире и сознательном осознании.",
    donationTitle: "Поддержите нашу миссию",
    donationDesc: "Ваш вклад помогает нам продолжать распространять мудрость, поддерживать сообщества и создавать образовательный контент для мира.",
    selectAmount: "Выберите сумму",
    custom: "Другая сумма",
    totalDonation: "Общая сумма пожертвования",
    securePayment: "Безопасная оплата через Stripe",
    taxDeductible: "Квитанция для налогового вычета",
    sandboxNote: "* Тестовый режим: имитирует транзакцию на realitysound24@gmail.com"
  }
};

// Add more languages with same structure (Hindi, French, Chinese, Tamil, Italian, Spanish)
translations.hi = { ...translations.en, name: "डॉ. नव्वाफ़ अलशिबली", title: "आध्यात्मिक मार्गदर्शक और ज्ञान शिक्षक" };
translations.fr = { ...translations.en, name: "Dr. Nawwaf Alshibli", title: "Guide spirituel et enseignant de sagesse" };
translations.zh = { ...translations.en, name: "纳瓦夫·阿尔希布利博士", title: "精神导师和智慧导师" };
translations.ta = { ...translations.en, name: "டாக்டர் நவ்வாஃப் அல்ஷிப்லி", title: "ஆன்மீக வழிகாட்டி மற்றும் ஞான ஆசிரியர்" };
translations.it = { ...translations.en, name: "Dr. Nawwaf Alshibli", title: "Guida spirituale e maestro di saggezza" };
translations.es = { ...translations.en, name: "Dr. Nawwaf Alshibli", title: "Guía espiritual y maestro de sabiduría" };

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');
  const [languageName, setLanguageName] = useState('English');
  
  const t = (key) => {
    return translations[language]?.[key] || translations.en[key] || key;
  };

  const changeLanguage = (langCode, langName) => {
    setLanguage(langCode);
    setLanguageName(langName);
  };

  const isRTL = language === 'ar';

  return (
    <LanguageContext.Provider value={{ language, languageName, t, changeLanguage, isRTL }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
